<div class="min-h-screen bg-gray-100 p-6">
  <div class="max-w-screen mx-auto bg-white rounded-xl shadow-md p-6">

    <div class="flex justify-between items-center mb-4">
      <h1 class="text-2xl font-bold text-gray-900 leading-tight">Expense History</h1>
      <a [routerLink]="addPath"
        class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-[#C19725] border-1 border-[#C19725] hover:bg-[#fdffc6] hover:text-[#C19725] hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
        Add Expense
      </a>
    </div>

    <!-- Tabs Navigation -->
    <div class="flex border-b border-gray-200 mb-6">
      <button (click)="switchTab('history')" [class.border-[#C19725]]="activeTab === 'history'"
        [class.text-[#C19725]]="activeTab === 'history'"
        class="px-6 py-3 text-sm font-bold uppercase tracking-wider border-b-2 transition-colors cursor-pointer"
        [class.border-transparent]="activeTab !== 'history'" [class.text-gray-500]="activeTab !== 'history'">
        Expense History
      </button>
      <button (click)="switchTab('analytics')" [class.border-[#C19725]]="activeTab === 'analytics'"
        [class.text-[#C19725]]="activeTab === 'analytics'"
        class="px-6 py-3 text-sm font-bold uppercase tracking-wider border-b-2 transition-colors cursor-pointer"
        [class.border-transparent]="activeTab !== 'analytics'" [class.text-gray-500]="activeTab !== 'analytics'">
        Analytics & Trends
      </button>
    </div>

    <!-- History Tab -->
    <div *ngIf="activeTab === 'history'">
      <div class="flex flex-wrap items-center gap-4 mb-4">
        <!-- Search Input -->
        <div class="flex-1 min-w-[200px]">
          <input type="text" [(ngModel)]="searchText" (ngModelChange)="filterTable()"
            placeholder="Search Type, Date or Amount..."
            class="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-[#C19725] focus:outline-none shadow-sm" />
        </div>

        <!-- Period Filter -->
        <div class="flex items-center gap-2">
          <label class="text-xs font-bold text-gray-500 uppercase tracking-tighter">Period:</label>
          <select [(ngModel)]="selectedPeriod" (change)="onPeriodChange()"
            class="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-[#C19725] focus:outline-none bg-white shadow-sm text-sm cursor-pointer min-w-[120px]">
            <option value="today">Today</option>
            <option value="month">This Month</option>
            <option value="year">This Year</option>
            <option value="all">All Time</option>
          </select>
        </div>

        <!-- Rows per page -->
        <div class="flex items-center gap-2">
          <label class="text-xs font-bold text-gray-500 uppercase tracking-tighter">Rows:</label>
          <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()"
            class="border border-gray-300 rounded-lg px-2 py-2 focus:ring-2 focus:ring-[#C19725] focus:outline-none bg-white shadow-sm text-sm cursor-pointer min-w-[70px]">
            <option [ngValue]="5">5</option>
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
        </div>

        <!-- Export Buttons -->
        <div class="flex items-center gap-2">
          <button (click)="exportToExcel()"
            class="flex items-center gap-2 px-3 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors border border-green-200 shadow-sm text-xs font-bold uppercase tracking-wider">
            <i class="fas fa-file-excel"></i>
            Excel
          </button>
          <button (click)="exportToPDF()"
            class="flex items-center gap-2 px-3 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors border border-red-200 shadow-sm text-xs font-bold uppercase tracking-wider">
            <i class="fas fa-file-pdf"></i>
            PDF
          </button>
          <button (click)="printExpenses()"
            class="flex items-center gap-2 px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors border border-blue-200 shadow-sm text-xs font-bold uppercase tracking-wider">
            <i class="fas fa-print"></i>
            Print
          </button>
        </div>

        <!-- Total Display (Updates on search) -->
        <div
          class="bg-red-50 text-red-700 font-bold px-4 py-2 rounded-lg shadow-sm border border-red-100 flex items-center gap-2 ml-auto">
          <span class="text-xs uppercase tracking-wider opacity-70">Total :</span>
          <span class="text-lg">{{ totalExpense | number:'1.2-2' }}</span>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full border border-gray-200 rounded-lg overflow-hidden">
          <thead class="bg-gray-100 text-gray-700 font-semibold">
            <tr>
              <th class="px-4 py-3 border-b">Sr. No.</th>
              <th class="px-4 py-3 border-b">Date</th>
              <th class="px-4 py-3 border-b">Type</th>
              <th class="px-4 py-3 border-b">Amount</th>
              <th class="px-4 py-3 border-b">Bill</th>
              <th class="px-4 py-3 border-b">Action</th>
            </tr>
          </thead>

          <tbody class="text-gray-800">
            <!-- Iterate over paginatedData -->
            <tr class="border-b" *ngFor="let expense of paginatedData; let i=index">
              <!-- Calculate correct Serial Number -->
              <td class="px-4 py-3 text-center">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
              <td class="px-4 py-3 text-center">{{ expense.date }}</td>
              <td class="px-4 py-3 text-center">{{ expense.expense_type?.name || expense.type }}</td>
              <td class="px-4 py-3 text-center">{{ expense.amount }}</td>
              <td class="px-4 py-3 text-center">
                <div *ngIf="expense.document" class="flex items-center justify-center">
                  <!-- Image Thumbnail -->
                  <img *ngIf="!expense.document.toLowerCase().endsWith('.pdf')" [src]="expense.document"
                    (click)="openDocument(expense.document)"
                    class="w-10 h-10 object-cover rounded shadow-sm cursor-pointer border border-gray-200 hover:scale-110 transition-transform"
                    title="Click to view full image" alt="Bill" />

                  <!-- PDF Icon -->
                  <div *ngIf="expense.document.toLowerCase().endsWith('.pdf')" (click)="openDocument(expense.document)"
                    class="w-10 h-10 flex items-center justify-center bg-red-100 text-red-600 rounded shadow-sm cursor-pointer border border-red-200 hover:scale-110 transition-transform"
                    title="Click to view PDF">
                    <i class="fas fa-file-pdf text-xl"></i>
                  </div>
                </div>
                <span *ngIf="!expense.document" class="text-gray-400 text-xs">-</span>
              </td>
              <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
                <div class="flex items-center justify-center gap-1 sm:gap-2">
                  <!-- View/Edit -->
                  <button class="cursor-pointer p-1" (click)="editExpense(expense.id)">
                    <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                        stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M14.7166 9.23962L8.10638 15.8499" stroke="#C19725" stroke-miterlimit="5"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <!-- Delete -->
                  <button class="cursor-pointer p-1" (click)="deleteExpense(expense.id)">
                    <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 25" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                        stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                        stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            <!-- Empty State -->
            <tr *ngIf="paginatedData.length === 0">
              <td colspan="6" class="px-4 py-8 text-center text-gray-500">
                No expenses found matching "{{ searchText }}".
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="flex items-center justify-between border-t border-gray-200 bg-white py-3 mt-4"
        *ngIf="filteredData.length > 0">
        <div class="flex items-center">
          <p class="text-sm text-gray-700">
            Showing
            <span class="font-medium">{{ (currentPage - 1) * itemsPerPage + 1 }}</span>
            to
            <span class="font-medium">{{ currentPage * itemsPerPage > filteredData.length ? filteredData.length :
              currentPage * itemsPerPage }}</span>
            of
            <span class="font-medium">{{ filteredData.length }}</span>
            entries
          </p>
        </div>
        <div class="flex sm:flex-1 sm:items-center sm:justify-end" *ngIf="totalPages > 1">
          <nav class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs">
            <!-- Previous -->
            <button (click)="goToPreviousPage()" [disabled]="currentPage === 1"
              class="relative inline-flex items-center justify-center w-8 h-8 rounded-[5px] text-[#C19725] ring-1 ring-[#C19725] ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed">
              <span class="sr-only">Previous</span>
              <svg class="size-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                  clip-rule="evenodd" />
              </svg>
            </button>
            <!-- Numbers -->
            <button *ngFor="let p of pageNumbers" (click)="goToPage(p)" [class.bg-[#C19725]]="currentPage === p"
              [class.text-white]="currentPage === p" [class.text-[#C19725]]="currentPage !== p"
              class="relative inline-flex items-center justify-center w-8 h-8 rounded-[5px] text-sm font-normal ring-1 ring-[#C19725] ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0">
              {{ p }}
            </button>
            <!-- Next -->
            <button (click)="goToNextPage()" [disabled]="currentPage === totalPages"
              class="relative inline-flex items-center justify-center w-8 h-8 rounded-[5px] text-[#C19725] ring-1 ring-[#C19725] ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed">
              <span class="sr-only">Next</span>
              <svg class="size-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                  clip-rule="evenodd" />
              </svg>
            </button>
          </nav>
        </div>
      </div>
    </div>

    <!-- Analytics Tab -->
    <div *ngIf="activeTab === 'analytics' && analyticsData" class="space-y-6 animate-in fade-in duration-500">
      <!-- KPI Cards -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="bg-white border border-gray-100 rounded-xl p-6 shadow-sm">
          <p class="text-xs font-bold text-gray-500 uppercase tracking-wider">Current Month</p>
          <div class="flex items-center justify-between mt-2">
            <h2 class="text-3xl font-bold text-gray-900">₹{{ analyticsData.kpis.current_month | number:'1.2-2' }}</h2>
          </div>
        </div>
        <div class="bg-white border border-gray-100 rounded-xl p-6 shadow-sm">
          <p class="text-xs font-bold text-gray-500 uppercase tracking-wider">Last Month</p>
          <div class="flex items-center justify-between mt-2">
            <h2 class="text-3xl font-bold text-gray-700">₹{{ analyticsData.kpis.last_month | number:'1.2-2' }}</h2>
          </div>
        </div>
        <div class="bg-white border rounded-xl p-6 shadow-sm"
          [ngClass]="analyticsData.kpis.diff_percent > 0 ? 'border-red-100 bg-red-50' : 'border-green-100 bg-green-50'">
          <p class="text-xs font-bold uppercase tracking-wider"
            [ngClass]="analyticsData.kpis.diff_percent > 0 ? 'text-red-500' : 'text-green-500'">
            {{ analyticsData.kpis.diff_percent > 0 ? 'Increase' : 'Decrease' }} vs Last Month
          </p>
          <div class="flex items-center justify-between mt-2">
            <h2 class="text-3xl font-bold"
              [ngClass]="analyticsData.kpis.diff_percent > 0 ? 'text-red-700' : 'text-green-700'">
              {{ (analyticsData.kpis.diff_percent < 0 ? -analyticsData.kpis.diff_percent :
                analyticsData.kpis.diff_percent) | number:'1.1-1' }}% </h2>
                <i class="fas"
                  [ngClass]="analyticsData.kpis.diff_percent > 0 ? 'fa-arrow-up text-red-400' : 'fa-arrow-down text-green-400'"></i>
          </div>
        </div>
      </div>

      <!-- Charts -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div class="bg-white border border-gray-200 rounded-xl p-6 shadow-sm min-h-[400px] flex flex-col">
          <h3 class="text-lg font-bold text-gray-800 mb-4 border-b border-gray-100 pb-2">Expense Type Caparison(Month)
          </h3>
          <div class="flex-1 relative">
            <canvas id="categoryChart"></canvas>
          </div>
        </div>
        <div class="bg-white border border-gray-200 rounded-xl p-6 shadow-sm min-h-[400px] flex flex-col">
          <h3 class="text-lg font-bold text-gray-800 mb-4 border-b border-gray-100 pb-2">Monthly Trends</h3>
          <div class="flex-1 relative">
            <canvas id="trendChart"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Analytics Loading State -->
    <div *ngIf="activeTab === 'analytics' && !analyticsData" class="flex flex-col items-center justify-center py-20">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C19725] mb-4"></div>
      <p class="text-gray-500 font-medium font-bold uppercase tracking-widest text-xs">Cooking your trends...</p>
    </div>

  </div>
</div>